import { render, staticRenderFns } from "./TSelector.vue?vue&type=template&id=5ad2b150&scoped=true&"
import script from "./TSelector.vue?vue&type=script&lang=js&"
export * from "./TSelector.vue?vue&type=script&lang=js&"
import style0 from "./TSelector.vue?vue&type=style&index=0&id=5ad2b150&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad2b150",
  null
  
)

export default component.exports